import { render, staticRenderFns } from "./MotherReport.vue?vue&type=template&id=097ceba4&scoped=true&"
import script from "./MotherReport.vue?vue&type=script&lang=js&"
export * from "./MotherReport.vue?vue&type=script&lang=js&"
import style0 from "./MotherReport.vue?vue&type=style&index=0&id=097ceba4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097ceba4",
  null
  
)

export default component.exports